module.exports = __webpack_public_path__ + "img/restaurant-7.ca2f2d57.jpg";